// event-bus.js

import Vue from 'vue';

// 创建一个新的 Vue 实例作为事件总线
const EventBus = new Vue();

// 导出事件总线对象
export default EventBus;



// WEBPACK FOOTER //
// ./src/router/event-bus.js